import { render, staticRenderFns } from "./OpportunitiesApproval.vue?vue&type=template&id=375d4ab5&scoped=true&"
import script from "./OpportunitiesApproval.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesApproval.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesApproval.vue?vue&type=style&index=0&id=375d4ab5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375d4ab5",
  null
  
)

export default component.exports